module.exports = __webpack_public_path__ + "images/emoji/id.05ebb775b43f50136d38.png";